/* Carousels */
export const CAROUSEL_VISUAL_RATIO = 1.95

/* Product card zones */
export const PRODUCT_CARD_GLOBAL_ZONE = 0
export const PRODUCT_CARD_PICTURE_ZONE = 1
export const PRODUCT_CARD_BUTTON_ZONE = 2

export const PRODUCT_CARD_MAX_LARGE_WIDTH = 754
export const PRODUCT_CARD_MAX_SMALL_WIDTH = 400

export const PRODUCT_CARD_SMALL_VISUAL_HEIGHT = 226

export const PRODUCT_CARD_HEIGHT_MEDIUM = 665
export const PRODUCT_CARD_HEIGHT_SMALL = 410

export const PRODUCT_CARD_HEIGHT_DESKTOP_SMALL = 655

export const PRODUCT_TAB_ASIDE_BLOCK_WIDTH = 333
